import { takeEvery, put, call, select, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';
import { updateDiscipleByMap } from 'src/components/therapyPlanning_2.0/commonComponent/updateSingleCellData';

const {
    GET_7DAY_LOOK_BACK_SUM_REQUEST,
    GET_7DAY_LOOK_BACK_SUM_SUCCESS,
    GET_7DAY_LOOK_BACK_SUM_FAILURE,
    GET_7DAY_LOOK_BACK_SUM_RESET,
    GET_7DAY_LOOK_BACK_SUM_LOADING,
} = therapyPlanningAction;

function* getTherapyPlanning7dayLook(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_7DAY_LOOK_BACK_SUM_LOADING,
        requestDiscipline: payload?.payload?.therapyType ? payload?.payload?.therapyType : 'ALL',
     });
    const response = yield call(therapyPlanningService.get7DayLookBack, payload?.payload);
    if (response?.status === 200) {
      // Guard: discard stale responses if patient changed since request was made
      const currentPatientUuid: string = yield select(
        (state: any) => state?.selectPatientReducer?.patientInfo?.uuid
      );
      if (payload?.payload?.patientId && payload?.payload?.patientId !== currentPatientUuid) {
        return;
      }
      yield put({
        type: GET_7DAY_LOOK_BACK_SUM_SUCCESS,
        payload: {
            response: response.data,
            therapyType: payload?.payload?.therapyType,
            requestPayload: payload?.payload?.params,
            source: payload?.payload?.source,
          },
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_7DAY_LOOK_BACK_SUM_FAILURE, payload: error });
  }
}

function* getTherapyPlanning7dayLookBackSaga() {
  yield takeEvery(GET_7DAY_LOOK_BACK_SUM_REQUEST, getTherapyPlanning7dayLook);
}

export default getTherapyPlanning7dayLookBackSaga;
